{
    "$schema": "http://json-schema.org/draft-07/schema",
    "type": "object",
    "properties": {
        "version": {
            "type": "number",
            "enum": [2]
        },
        "models": {
            "type": "array",
            "items": {
                "type": "object",
                "properties": {
                    "name": {
                        "type": "string"
                    },
                    "description": {
                        "type": "string"
                    },
                    "docs": {
                        "type": "object",
                        "properties": {
                            "show": {
                                "type": "boolean"
                            }
                        }
                    },
                    "tests": {
                        "type": "array",
                        "items": {
                            "anyOf": [
                                {
                                    "type": "object"
                                },
                                {
                                    "type": "string"
                                }
                            ]
                        }
                    },
                    "data_tests": {
                        "type": "array",
                        "items": {
                            "anyOf": [
                                {
                                    "type": "object"
                                },
                                {
                                    "type": "string"
                                }
                            ]
                        }
                    },
                    "meta": {
                        "$ref": "#/$defs/modelMeta"
                    },
                    "columns": {
                        "type": "array",
                        "items": {
                            "type": "object",
                            "properties": {
                                "name": {
                                    "type": "string"
                                },
                                "description": {
                                    "type": "string"
                                },
                                "quote": {
                                    "type": "boolean"
                                },
                                "tests": {
                                    "type": "array",
                                    "items": {
                                        "anyOf": [
                                            {
                                                "type": "object"
                                            },
                                            {
                                                "type": "string"
                                            }
                                        ]
                                    }
                                },
                                "data_tests": {
                                    "type": "array",
                                    "items": {
                                        "anyOf": [
                                            {
                                                "type": "object"
                                            },
                                            {
                                                "type": "string"
                                            }
                                        ]
                                    }
                                },
                                "tags": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                },
                                "meta": {
                                    "$ref": "#/$defs/columnMeta"
                                },
                                "config": {
                                    "type": "object",
                                    "properties": {
                                        "meta": {
                                            "$ref": "#/$defs/columnMeta"
                                        }
                                    }
                                }
                            }
                        }
                    },
                    "config": {
                        "type": "object",
                        "properties": {
                            "meta": {
                                "$ref": "#/$defs/modelMeta"
                            }
                        }
                    }
                },
                "required": ["name"]
            }
        },
        "metrics": {
            "type": "array",
            "items": {
                "type": "object",
                "properties": {
                    "name": {
                        "type": "string"
                    },
                    "model": {
                        "type": "string"
                    },
                    "label": {
                        "type": "string"
                    },
                    "description": {
                        "type": "string"
                    },
                    "type": {
                        "type": "string"
                    },
                    "sql": {
                        "type": "string"
                    },
                    "timestamp": {
                        "type": "string"
                    },
                    "time_grains": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "dimensions": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "filters": {
                        "type": "array",
                        "items": {
                            "type": "object"
                        }
                    },
                    "meta": {
                        "type": "object",
                        "properties": {
                            "hidden": {
                                "type": "boolean"
                            },
                            "round": {
                                "type": "number",
                                "minimum": 0
                            },
                            "format": {
                                "type": "string"
                            },
                            "separator": {
                                "$ref": "#/$defs/separator"
                            },
                            "compact": {
                                "type": "string",
                                "enum": [
                                    "auto",
                                    "thousands",
                                    "millions",
                                    "billions",
                                    "trillions",
                                    "thousand",
                                    "million",
                                    "billion",
                                    "trillion",
                                    "K",
                                    "M",
                                    "B",
                                    "T",
                                    "kilobytes",
                                    "megabytes",
                                    "gigabytes",
                                    "terabytes",
                                    "petabytes",
                                    "kilobyte",
                                    "megabyte",
                                    "gigabyte",
                                    "terabyte",
                                    "petabyte",
                                    "KB",
                                    "MB",
                                    "GB",
                                    "TB",
                                    "PB",
                                    "kibibytes",
                                    "mebibytes",
                                    "gibibytes",
                                    "tebibytes",
                                    "pebibytes",
                                    "kibibyte",
                                    "mebibyte",
                                    "gibibyte",
                                    "tebibyte",
                                    "pebibyte",
                                    "KiB",
                                    "MiB",
                                    "GiB",
                                    "TiB",
                                    "PiB"
                                ]
                            },
                            "urls": {
                                "type": "array",
                                "items": {
                                    "type": "object",
                                    "properties": {
                                        "url": {
                                            "type": "string",
                                            "description": "Liquidjs template for the URL. Available variables: ${value.raw}, ${value.formatted}, ${row.table_name.field_name.raw}, ${row.table_name.field_name.formatted}"
                                        },
                                        "label": {
                                            "type": "string"
                                        }
                                    }
                                }
                            },
                            "image": {
                                "type": "object",
                                "description": "Displays the dimension value as an image",
                                "properties": {
                                    "url": {
                                        "type": "string",
                                        "description": "Liquidjs template for the image URL. Available variables: ${value.raw}, ${value.formatted}, ${row.table_name.field_name.raw}, ${row.table_name.field_name.formatted}. Only fields selected in the query are available in row context."
                                    }
                                },
                                "required": ["url"]
                            },
                            "tags": {
                                "oneOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    }
                                ]
                            },
                            "show_underlying_values": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "default_time_dimension": {
                                "type": "object",
                                "description": "Specifies the default time dimension field and interval to use for time-based analysis on this metric. If specified, both field and interval are required. If there is already a default time dimension set in the model, this will override it.",
                                "properties": {
                                    "field": {
                                        "type": "string",
                                        "description": "The name of the field to use as the default time dimension"
                                    },
                                    "interval": {
                                        "type": "string",
                                        "enum": [
                                            "DAY",
                                            "WEEK",
                                            "MONTH",
                                            "YEAR"
                                        ],
                                        "description": "The default time interval to use when analyzing this time dimension"
                                    }
                                },
                                "required": ["field", "interval"]
                            },
                            "spotlight": {
                                "type": "object",
                                "description": "Set the visibility and/or categories of a metric in Spotlight",
                                "properties": {
                                    "visibility": {
                                        "type": "string",
                                        "enum": ["show", "hide"]
                                    },
                                    "categories": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        },
                                        "description": "An array of categories for the metric in Spotlight"
                                    },
                                    "filter_by": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        },
                                        "description": "An array of dimension names that are allowed for filtering this metric in the Metrics Explorer"
                                    },
                                    "segment_by": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        },
                                        "description": "An array of dimension names that are allowed for segmenting this metric in the Metrics Explorer"
                                    },
                                    "default_segment": {
                                        "type": "string",
                                        "description": "A dimension name pre-selected in the Segment by picker when this metric is opened in the Metrics Explorer. Must be one of segment_by (if set) and a segmentable dimension."
                                    },
                                    "default_filter": {
                                        "type": "object",
                                        "description": "A single filter pre-applied when this metric is opened in the Metrics Explorer, e.g. { status: active } or { status: [active, pending] }. Uses the metric filter syntax; only is / is not operators are supported here.",
                                        "additionalProperties": true,
                                        "maxProperties": 1
                                    },
                                    "owner": {
                                        "type": "string",
                                        "description": "Email of the metric owner"
                                    }
                                },
                                "anyOf": [
                                    {
                                        "required": ["visibility"]
                                    },
                                    {
                                        "required": ["categories"]
                                    },
                                    {
                                        "required": ["filter_by"]
                                    },
                                    {
                                        "required": ["segment_by"]
                                    },
                                    {
                                        "required": ["owner"]
                                    }
                                ]
                            }
                        }
                    }
                },
                "required": ["name"]
            }
        },
        "seeds": {
            "type": "array",
            "items": {
                "type": "object"
            }
        },
        "snapshots": {
            "type": "array",
            "items": {
                "type": "object"
            }
        },
        "tests": {
            "type": "array",
            "items": {
                "type": "object"
            }
        },
        "unit_tests": {
            "type": "array",
            "items": {
                "type": "object"
            }
        },
        "sources": {
            "type": "array",
            "items": {
                "type": "object"
            }
        },
        "analyses": {
            "type": "array",
            "items": {
                "type": "object"
            }
        },
        "exposures": {
            "type": "array",
            "items": {
                "type": "object"
            }
        },
        "macros": {
            "type": "array",
            "items": {
                "type": "object"
            }
        }
    },
    "additionalProperties": false,
    "required": [],
    "$defs": {
        "separator": {
            "type": "string",
            "enum": [
                "default",
                "commaPeriod",
                "spacePeriod",
                "periodComma",
                "noSeparatorPeriod",
                "apostrophePeriod"
            ]
        },
        "aiHint": {
            "oneOf": [
                {
                    "type": "string"
                },
                {
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                }
            ]
        },
        "filterItem": {
            "type": "object",
            "additionalProperties": {
                "oneOf": [
                    { "type": "string" },
                    { "type": "array", "items": { "type": "string" } }
                ]
            },
            "properties": {
                "required": {
                    "type": "boolean",
                    "description": "If true, this filter cannot be removed by users"
                }
            }
        },
        "modelMeta": {
            "type": "object",
            "properties": {
                "joins": {
                    "type": "array",
                    "items": {
                        "type": "object",
                        "properties": {
                            "join": {
                                "type": "string"
                            },
                            "sql_on": {
                                "type": "string"
                            },
                            "always": {
                                "type": "boolean"
                            },
                            "type": {
                                "type": "string",
                                "enum": ["inner", "left", "right", "full"]
                            },
                            "hidden": {
                                "type": "boolean"
                            },
                            "alias": {
                                "type": "string"
                            },
                            "label": {
                                "type": "string"
                            },
                            "fields": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                },
                                "description": "Fields to include from the joined model. Use set references (ending with *) to include sets and a - prefix to exclude fields or sets. A list containing only exclusions includes every field except those excluded."
                            },
                            "relationship": {
                                "type": "string",
                                "enum": [
                                    "one-to-many",
                                    "many-to-one",
                                    "one-to-one",
                                    "many-to-many"
                                ]
                            }
                        },
                        "required": ["join", "sql_on"]
                    }
                },
                "order_fields_by": {
                    "type": "string",
                    "enum": ["index", "label"]
                },
                "group_label": {
                    "type": "string",
                    "deprecated": true,
                    "description": "Deprecated: use groups instead"
                },
                "groups": {
                    "type": "array",
                    "description": "Groups are used to group tables in the sidebar. You can create nested groups up to 5 levels. Define labels & descriptions for the group keys in lightdash.config.yml under table_groups.",
                    "items": {
                        "type": "string",
                        "minLength": 1
                    },
                    "maxItems": 5
                },
                "group_details": {
                    "type": "object",
                    "description": "Set up group_details so you can group your dimensions and metrics in the sidebar using the groups parameter. You can create nested groups up to 5 levels",
                    "patternProperties": {
                        "^[a-zA-Z0-9_]+$": {
                            "type": "object",
                            "properties": {
                                "label": {
                                    "type": "string",
                                    "minLength": 1
                                },
                                "description": {
                                    "type": "string"
                                },
                                "ai_hint": {
                                    "$ref": "#/$defs/aiHint",
                                    "description": "Hints inherited by fields in this group for AI-powered query generation"
                                }
                            },
                            "required": ["label"]
                        }
                    }
                },
                "ai_hint": {
                    "$ref": "#/$defs/aiHint",
                    "description": "Hints for AI-powered query generation"
                },
                "metrics": {
                    "type": "object",
                    "patternProperties": {
                        "^[a-z0-9_]+$": {
                            "type": "object",
                            "properties": {
                                "type": {
                                    "type": "string",
                                    "enum": [
                                        "percentile",
                                        "median",
                                        "average",
                                        "boolean",
                                        "count",
                                        "count_distinct",
                                        "date",
                                        "max",
                                        "min",
                                        "number",
                                        "string",
                                        "sum",
                                        "percent_of_previous",
                                        "percent_of_total",
                                        "running_total",
                                        "sum_distinct",
                                        "average_distinct"
                                    ]
                                },
                                "label": {
                                    "type": "string",
                                    "minLength": 1
                                },
                                "description": {
                                    "type": "string",
                                    "minLength": 1
                                },
                                "ai_hint": {
                                    "$ref": "#/$defs/aiHint",
                                    "description": "Hints for AI-powered query generation"
                                },
                                "sql": {
                                    "type": "string",
                                    "minLength": 1
                                },
                                "hidden": {
                                    "type": "boolean"
                                },
                                "distinct_keys": {
                                    "oneOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        }
                                    ]
                                },
                                "round": {
                                    "description": "Rounds the metric to the specified number of decimal places",
                                    "type": "number",
                                    "minimum": 0
                                },
                                "format": {
                                    "type": "string"
                                },
                                "separator": {
                                    "$ref": "#/$defs/separator"
                                },
                                "percentile": {
                                    "type": "number"
                                },
                                "compact": {
                                    "type": "string",
                                    "enum": [
                                        "auto",
                                        "thousands",
                                        "millions",
                                        "billions",
                                        "trillions",
                                        "thousand",
                                        "million",
                                        "billion",
                                        "trillion",
                                        "K",
                                        "M",
                                        "B",
                                        "T",
                                        "kilobytes",
                                        "megabytes",
                                        "gigabytes",
                                        "terabytes",
                                        "petabytes",
                                        "kilobyte",
                                        "megabyte",
                                        "gigabyte",
                                        "terabyte",
                                        "petabyte",
                                        "KB",
                                        "MB",
                                        "GB",
                                        "TB",
                                        "PB",
                                        "kibibytes",
                                        "mebibytes",
                                        "gibibytes",
                                        "tebibytes",
                                        "pebibytes",
                                        "kibibyte",
                                        "mebibyte",
                                        "gibibyte",
                                        "tebibyte",
                                        "pebibyte",
                                        "KiB",
                                        "MiB",
                                        "GiB",
                                        "TiB",
                                        "PiB"
                                    ]
                                },
                                "urls": {
                                    "type": "array",
                                    "items": {
                                        "type": "object",
                                        "properties": {
                                            "url": {
                                                "type": "string",
                                                "description": "Liquidjs template for the URL. Available variables: ${value.raw}, ${value.formatted}, ${row.table_name.field_name.raw}, ${row.table_name.field_name.formatted}"
                                            },
                                            "label": {
                                                "type": "string"
                                            }
                                        }
                                    }
                                },
                                "image": {
                                    "type": "object",
                                    "description": "Displays the dimension value as an image",
                                    "properties": {
                                        "url": {
                                            "type": "string",
                                            "description": "Liquidjs template for the image URL. Available variables: ${value.raw}, ${value.formatted}, ${row.table_name.field_name.raw}, ${row.table_name.field_name.formatted}. Only fields selected in the query are available in row context."
                                        },
                                        "width": {
                                            "type": "number"
                                        },
                                        "height": {
                                            "type": "number"
                                        },
                                        "fit": {
                                            "type": "string"
                                        }
                                    },
                                    "required": ["url"]
                                },
                                "tags": {
                                    "oneOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        }
                                    ]
                                },
                                "show_underlying_values": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                },
                                "groups": {
                                    "type": "array",
                                    "description": "Groups are used to group dimensions and metrics in the sidebar. You can create nested groups up to 5 levels",
                                    "items": {
                                        "type": "string",
                                        "minLength": 1
                                    },
                                    "maxItems": 5
                                },
                                "default_time_dimension": {
                                    "type": "object",
                                    "description": "Specifies the default time dimension field and interval to use for time-based analysis on this metric. If specified, both field and interval are required. If there is already a default time dimension set in the model, this will override it.",
                                    "properties": {
                                        "field": {
                                            "type": "string",
                                            "description": "The name of the field to use as the default time dimension"
                                        },
                                        "interval": {
                                            "type": "string",
                                            "enum": [
                                                "DAY",
                                                "WEEK",
                                                "MONTH",
                                                "YEAR"
                                            ],
                                            "description": "The default time interval to use when analyzing this time dimension"
                                        }
                                    },
                                    "required": ["field", "interval"]
                                },
                                "required_attributes": {
                                    "type": "object",
                                    "properties": {},
                                    "additionalProperties": {
                                        "oneOf": [
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "string"
                                            }
                                        ]
                                    }
                                },
                                "any_attributes": {
                                    "type": "object",
                                    "properties": {},
                                    "additionalProperties": {
                                        "oneOf": [
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "string"
                                            }
                                        ]
                                    }
                                },
                                "spotlight": {
                                    "type": "object",
                                    "description": "Set the visibility and/or categories of a metric in Spotlight",
                                    "properties": {
                                        "visibility": {
                                            "type": "string",
                                            "enum": ["show", "hide"]
                                        },
                                        "categories": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            },
                                            "description": "An array of categories for the metric in Spotlight"
                                        },
                                        "filter_by": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            },
                                            "description": "An array of dimension names that are allowed for filtering this metric in the Metrics Explorer"
                                        },
                                        "segment_by": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            },
                                            "description": "An array of dimension names that are allowed for segmenting this metric in the Metrics Explorer"
                                        },
                                        "default_segment": {
                                            "type": "string",
                                            "description": "A dimension name pre-selected in the Segment by picker when this metric is opened in the Metrics Explorer. Must be one of segment_by (if set) and a segmentable dimension."
                                        },
                                        "default_filter": {
                                            "type": "object",
                                            "description": "A single filter pre-applied when this metric is opened in the Metrics Explorer, e.g. { status: active } or { status: [active, pending] }. Uses the metric filter syntax; only is / is not operators are supported here.",
                                            "additionalProperties": true,
                                            "maxProperties": 1
                                        },
                                        "owner": {
                                            "type": "string",
                                            "description": "Email of the metric owner"
                                        }
                                    },
                                    "anyOf": [
                                        {
                                            "required": ["visibility"]
                                        },
                                        {
                                            "required": ["categories"]
                                        },
                                        {
                                            "required": ["filter_by"]
                                        },
                                        {
                                            "required": ["segment_by"]
                                        },
                                        {
                                            "required": ["owner"]
                                        }
                                    ]
                                },
                                "drivers": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    },
                                    "description": "Array of metrics that drive this metric. Use 'metric_name' for same-table or 'table.metric_name' for cross-table."
                                }
                            },
                            "required": ["type", "sql"]
                        }
                    }
                },
                "default_time_dimension": {
                    "type": "object",
                    "description": "Specifies the default time dimension field and interval to use for time-based analysis (on any metric in the model). If specified, both field and interval are required.",
                    "properties": {
                        "field": {
                            "type": "string",
                            "description": "The name of the field to use as the default time dimension"
                        },
                        "interval": {
                            "type": "string",
                            "enum": ["DAY", "WEEK", "MONTH", "YEAR"],
                            "description": "The default time interval to use when analyzing this time dimension"
                        }
                    },
                    "required": ["field", "interval"]
                },
                "default_show_underlying_values": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    },
                    "description": "Default show underlying values configuration that will be applied to all metrics in this model that don't have their own show_underlying_values defined"
                },
                "pre_aggregates": {
                    "type": "array",
                    "items": {
                        "type": "object",
                        "properties": {
                            "name": {
                                "type": "string"
                            },
                            "dimensions": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "metrics": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "table": {
                                "type": "string",
                                "minLength": 1,
                                "pattern": "^(?:[A-Za-z_][A-Za-z0-9_$]*|\"(?:\"\"|[^\"\\u0000-\\u001F])+\"|`[^`\\u0000-\\u001F]+`)(?:\\.(?:[A-Za-z_][A-Za-z0-9_$]*|\"(?:\"\"|[^\"\\u0000-\\u001F])+\"|`[^`\\u0000-\\u001F]+`))*$",
                                "description": "External table: a qualified identifier for a customer-managed warehouse table or view that Lightdash does not create or refresh. It must expose the pre-aggregate's generated column names. When set, Lightdash never materializes this pre-aggregate; materialization keys (refresh, sorts, max_rows, materialization_role) are ignored."
                            },
                            "sorts": {
                                "description": "Materialization sort order. When omitted, Lightdash automatically sorts the time dimension first and descending, then all remaining materialized dimensions ascending. Set to false or [] to disable sorting, or provide canonical query sort entries with a compiled Lightdash fieldId and explicit descending value. Compiled time-dimension IDs include granularity (for example, orders_order_date_day) and must be updated when granularity changes. Sort order determines which rows are retained when max_rows truncates results.",
                                "oneOf": [
                                    {
                                        "const": false
                                    },
                                    {
                                        "type": "array",
                                        "items": {
                                            "type": "object",
                                            "properties": {
                                                "fieldId": {
                                                    "type": "string",
                                                    "minLength": 1
                                                },
                                                "descending": {
                                                    "description": "Whether to sort descending. Must be an unquoted YAML boolean.",
                                                    "enum": [true, false]
                                                }
                                            },
                                            "required": [
                                                "fieldId",
                                                "descending"
                                            ],
                                            "additionalProperties": false
                                        }
                                    }
                                ]
                            },
                            "filters": {
                                "type": "array",
                                "items": {
                                    "type": "object"
                                }
                            },
                            "time_dimension": {
                                "type": "string"
                            },
                            "granularity": {
                                "type": "string"
                            },
                            "max_rows": {
                                "type": "integer"
                            },
                            "refresh": {
                                "type": "object",
                                "properties": {
                                    "cron": {
                                        "type": "string",
                                        "description": "Cron expression for scheduled materialization"
                                    },
                                    "on_change": {
                                        "type": "boolean",
                                        "description": "Whether the project compile that changes this pre-aggregate's definition, or the fields it reads, rebuilds it. Defaults to true. Set to false to leave the rebuild to the cron schedule or a manual refresh; the old materialization stops serving either way. Compiles that leave the definition unchanged never rebuild it.",
                                        "default": true
                                    }
                                }
                            },
                            "materialization_role": {
                                "type": "object",
                                "properties": {
                                    "email": {
                                        "type": "string"
                                    },
                                    "attributes": {
                                        "type": "object",
                                        "properties": {},
                                        "additionalProperties": {
                                            "oneOf": [
                                                {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                {
                                                    "type": "string"
                                                }
                                            ]
                                        }
                                    }
                                },
                                "required": ["email", "attributes"],
                                "additionalProperties": false
                            }
                        },
                        "required": ["name", "dimensions", "metrics"]
                    }
                },
                "spotlight": {
                    "type": "object",
                    "description": "Set the visibility and/or categories of a metric in Spotlight",
                    "properties": {
                        "visibility": {
                            "type": "string",
                            "enum": ["show", "hide"]
                        },
                        "categories": {
                            "type": "array",
                            "items": {
                                "type": "string"
                            },
                            "description": "An optional array of categories for all metrics in this model in Spotlight"
                        },
                        "owner": {
                            "type": "string",
                            "description": "Email of the model owner (inherited by all metrics)"
                        }
                    },
                    "anyOf": [
                        {
                            "required": ["visibility"]
                        },
                        {
                            "required": ["categories"]
                        },
                        {
                            "required": ["owner"]
                        }
                    ]
                },
                "primary_key": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        }
                    ]
                },
                "owner": {
                    "type": "string",
                    "description": "Email of the model owner (inherited by all metrics). spotlight.owner takes precedence."
                },
                "sql_where": {
                    "type": "string"
                },
                "sql_filter": {
                    "type": "string"
                },
                "sql_from": {
                    "type": "string"
                },
                "required_attributes": {
                    "type": "object",
                    "properties": {},
                    "additionalProperties": {
                        "oneOf": [
                            {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            {
                                "type": "string"
                            }
                        ]
                    }
                },
                "any_attributes": {
                    "type": "object",
                    "properties": {},
                    "additionalProperties": {
                        "oneOf": [
                            {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            {
                                "type": "string"
                            }
                        ]
                    }
                },
                "parameters": {
                    "type": ["object", "null"],
                    "description": "Define parameters that can be used in SQL queries",
                    "patternProperties": {
                        "^[a-zA-Z0-9_-]+$": {
                            "type": "object",
                            "properties": {
                                "label": {
                                    "description": "The label of the parameter as it will be displayed in the UI",
                                    "type": "string"
                                },
                                "type": {
                                    "description": "The data type of the parameter (defaults to 'string' for backwards compatibility)",
                                    "type": "string",
                                    "enum": ["string", "number", "date"],
                                    "default": "string"
                                },
                                "description": {
                                    "description": "A description of the parameter",
                                    "type": "string"
                                },
                                "options": {
                                    "description": "A list of possible values for the parameter",
                                    "type": "array",
                                    "minItems": 1,
                                    "items": {
                                        "type": ["string", "number"]
                                    }
                                },
                                "default": {
                                    "description": "The default value(s) for the parameter. For date parameters, `today` resolves to the current date at query time.",
                                    "oneOf": [
                                        {
                                            "type": ["string", "number"]
                                        },
                                        {
                                            "type": "array",
                                            "items": {
                                                "type": ["string", "number"]
                                            }
                                        }
                                    ]
                                },
                                "multiple": {
                                    "description": "Whether the parameter input will be a multi select",
                                    "type": "boolean"
                                },
                                "allow_custom_values": {
                                    "description": "Whether users can input custom values beyond predefined options",
                                    "type": "boolean"
                                },
                                "options_from_dimension": {
                                    "description": "Get parameter options from a dimension in a model",
                                    "type": "object",
                                    "properties": {
                                        "model": {
                                            "description": "The model containing the dimension",
                                            "type": "string"
                                        },
                                        "dimension": {
                                            "description": "The dimension to get options from",
                                            "type": "string"
                                        }
                                    },
                                    "required": ["model", "dimension"]
                                }
                            },
                            "required": ["label"],
                            "anyOf": [
                                {
                                    "required": ["options_from_dimension"],
                                    "errorMessage": "Must have one of the following properties: allow_custom_values, options, options_from_dimension"
                                },
                                {
                                    "required": ["options"],
                                    "errorMessage": "Must have one of the following properties: allow_custom_values, options, options_from_dimension"
                                },
                                {
                                    "properties": {
                                        "allow_custom_values": {
                                            "enum": [true]
                                        }
                                    },
                                    "required": ["allow_custom_values"],
                                    "errorMessage": "Must have one of the following properties: allow_custom_values, options, options_from_dimension"
                                }
                            ]
                        }
                    }
                },
                "default_filters": {
                    "type": "array",
                    "description": "Default filters that are automatically applied when exploring this model",
                    "items": { "$ref": "#/$defs/filterItem" }
                },
                "required_filters": {
                    "type": "array",
                    "description": "Alias for default_filters (deprecated, use default_filters instead)",
                    "items": { "$ref": "#/$defs/filterItem" }
                },
                "hidden": {
                    "type": "boolean",
                    "description": "When true, no explore is generated for the model itself. The model is still available as a join target and as the base table for explores defined under `explores`."
                },
                "explores": {
                    "type": "object",
                    "description": "Defines custom explores for this model",
                    "patternProperties": {
                        "^[a-zA-Z0-9_]+$": {
                            "type": "object",
                            "properties": {
                                "default_filters": {
                                    "type": "array",
                                    "description": "Default filters that are automatically applied when exploring this explore",
                                    "items": { "$ref": "#/$defs/filterItem" }
                                },
                                "required_filters": {
                                    "type": "array",
                                    "description": "Alias for default_filters (deprecated, use default_filters instead)",
                                    "items": { "$ref": "#/$defs/filterItem" }
                                },
                                "tags": {
                                    "oneOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        }
                                    ],
                                    "description": "Tags for organizing and filtering this explore. Overrides model tags when set."
                                },
                                "sql_filter": {
                                    "type": "string",
                                    "description": "SQL filter applied to the WHERE clause of all queries using this explore"
                                },
                                "sql_where": {
                                    "type": "string",
                                    "description": "Alias for sql_filter (deprecated, use sql_filter instead)"
                                },
                                "group_label": {
                                    "type": "string",
                                    "deprecated": true,
                                    "description": "Deprecated: use groups instead"
                                },
                                "groups": {
                                    "type": "array",
                                    "description": "Groups are used to group tables in the sidebar. You can create nested groups up to 5 levels. Define labels & descriptions for the group keys in lightdash.config.yml under table_groups.",
                                    "items": {
                                        "type": "string",
                                        "minLength": 1
                                    },
                                    "maxItems": 5
                                }
                            }
                        }
                    }
                }
            }
        },
        "columnMeta": {
            "type": "object",
            "properties": {
                "metrics": {
                    "type": "object",
                    "patternProperties": {
                        "^[a-z0-9_]+$": {
                            "type": "object",
                            "properties": {
                                "type": {
                                    "type": "string",
                                    "enum": [
                                        "percentile",
                                        "median",
                                        "average",
                                        "boolean",
                                        "count",
                                        "count_distinct",
                                        "date",
                                        "max",
                                        "min",
                                        "number",
                                        "string",
                                        "sum",
                                        "percent_of_previous",
                                        "percent_of_total",
                                        "running_total",
                                        "sum_distinct",
                                        "average_distinct"
                                    ]
                                },
                                "label": {
                                    "type": "string",
                                    "minLength": 1
                                },
                                "description": {
                                    "type": "string",
                                    "minLength": 1
                                },
                                "ai_hint": {
                                    "$ref": "#/$defs/aiHint",
                                    "description": "Hints for AI-powered query generation"
                                },
                                "sql": {
                                    "type": "string",
                                    "minLength": 1
                                },
                                "hidden": {
                                    "type": "boolean"
                                },
                                "distinct_keys": {
                                    "oneOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        }
                                    ]
                                },
                                "round": {
                                    "type": "number",
                                    "minimum": 0
                                },
                                "format": {
                                    "type": "string"
                                },
                                "separator": {
                                    "$ref": "#/$defs/separator"
                                },
                                "percentile": {
                                    "type": "number"
                                },
                                "compact": {
                                    "type": "string",
                                    "enum": [
                                        "auto",
                                        "thousands",
                                        "millions",
                                        "billions",
                                        "trillions",
                                        "thousand",
                                        "million",
                                        "billion",
                                        "trillion",
                                        "K",
                                        "M",
                                        "B",
                                        "T",
                                        "kilobytes",
                                        "megabytes",
                                        "gigabytes",
                                        "terabytes",
                                        "petabytes",
                                        "kilobyte",
                                        "megabyte",
                                        "gigabyte",
                                        "terabyte",
                                        "petabyte",
                                        "KB",
                                        "MB",
                                        "GB",
                                        "TB",
                                        "PB",
                                        "kibibytes",
                                        "mebibytes",
                                        "gibibytes",
                                        "tebibytes",
                                        "pebibytes",
                                        "kibibyte",
                                        "mebibyte",
                                        "gibibyte",
                                        "tebibyte",
                                        "pebibyte",
                                        "KiB",
                                        "MiB",
                                        "GiB",
                                        "TiB",
                                        "PiB"
                                    ]
                                },
                                "urls": {
                                    "type": "array",
                                    "items": {
                                        "type": "object",
                                        "properties": {
                                            "url": {
                                                "type": "string",
                                                "description": "Liquidjs template for the URL. Available variables: ${value.raw}, ${value.formatted}, ${row.table_name.field_name.raw}, ${row.table_name.field_name.formatted}"
                                            },
                                            "label": {
                                                "type": "string"
                                            }
                                        }
                                    }
                                },
                                "image": {
                                    "type": "object",
                                    "description": "Displays the dimension value as an image",
                                    "properties": {
                                        "url": {
                                            "type": "string",
                                            "description": "Liquidjs template for the image URL. Available variables: ${value.raw}, ${value.formatted}, ${row.table_name.field_name.raw}, ${row.table_name.field_name.formatted}. Only fields selected in the query are available in row context."
                                        }
                                    },
                                    "required": ["url"]
                                },
                                "tags": {
                                    "oneOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        }
                                    ]
                                },
                                "show_underlying_values": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                },
                                "groups": {
                                    "type": "array",
                                    "description": "Groups are used to group dimensions and metrics in the sidebar. You can create nested groups up to 5 levels",
                                    "items": {
                                        "type": "string",
                                        "minLength": 1
                                    },
                                    "maxItems": 5
                                },
                                "default_time_dimension": {
                                    "type": "object",
                                    "description": "Specifies the default time dimension field and interval to use for time-based analysis on this metric. If specified, both field and interval are required. If there is already a default time dimension set in the model, this will override it.",
                                    "properties": {
                                        "field": {
                                            "type": "string",
                                            "description": "The name of the field to use as the default time dimension"
                                        },
                                        "interval": {
                                            "type": "string",
                                            "enum": [
                                                "DAY",
                                                "WEEK",
                                                "MONTH",
                                                "YEAR"
                                            ],
                                            "description": "The default time interval to use when analyzing this time dimension"
                                        }
                                    },
                                    "required": ["field", "interval"]
                                },
                                "required_attributes": {
                                    "type": "object",
                                    "properties": {},
                                    "additionalProperties": {
                                        "oneOf": [
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "string"
                                            }
                                        ]
                                    }
                                },
                                "any_attributes": {
                                    "type": "object",
                                    "properties": {},
                                    "additionalProperties": {
                                        "oneOf": [
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "string"
                                            }
                                        ]
                                    }
                                },
                                "spotlight": {
                                    "type": "object",
                                    "description": "Set the visibility and/or categories of a metric in Spotlight",
                                    "properties": {
                                        "visibility": {
                                            "type": "string",
                                            "enum": ["show", "hide"]
                                        },
                                        "categories": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            },
                                            "description": "An array of categories for the metric in Spotlight"
                                        },
                                        "filter_by": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            },
                                            "description": "An array of dimension names that are allowed for filtering this metric in the Metrics Explorer"
                                        },
                                        "segment_by": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            },
                                            "description": "An array of dimension names that are allowed for segmenting this metric in the Metrics Explorer"
                                        },
                                        "default_segment": {
                                            "type": "string",
                                            "description": "A dimension name pre-selected in the Segment by picker when this metric is opened in the Metrics Explorer. Must be one of segment_by (if set) and a segmentable dimension."
                                        },
                                        "default_filter": {
                                            "type": "object",
                                            "description": "A single filter pre-applied when this metric is opened in the Metrics Explorer, e.g. { status: active } or { status: [active, pending] }. Uses the metric filter syntax; only is / is not operators are supported here.",
                                            "additionalProperties": true,
                                            "maxProperties": 1
                                        },
                                        "owner": {
                                            "type": "string",
                                            "description": "Email of the metric owner"
                                        }
                                    },
                                    "anyOf": [
                                        {
                                            "required": ["visibility"]
                                        },
                                        {
                                            "required": ["categories"]
                                        },
                                        {
                                            "required": ["filter_by"]
                                        },
                                        {
                                            "required": ["segment_by"]
                                        },
                                        {
                                            "required": ["owner"]
                                        }
                                    ]
                                },
                                "drivers": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    },
                                    "description": "Array of metrics that drive this metric. Use 'metric_name' for same-table or 'table.metric_name' for cross-table."
                                }
                            },
                            "required": ["type"]
                        }
                    }
                },
                "dimension": {
                    "type": "object",
                    "properties": {
                        "type": {
                            "type": "string",
                            "enum": [
                                "string",
                                "number",
                                "timestamp",
                                "date",
                                "boolean"
                            ]
                        },
                        "label": {
                            "type": "string",
                            "minLength": 1
                        },
                        "description": {
                            "type": "string",
                            "minLength": 1
                        },
                        "ai_hint": {
                            "$ref": "#/$defs/aiHint",
                            "description": "Hints for AI-powered query generation"
                        },
                        "sql": {
                            "type": "string",
                            "minLength": 1
                        },
                        "convert_timezone": {
                            "type": "boolean",
                            "description": "When false, this dimension is rendered in its raw warehouse value and is not converted to the project timezone for display. Filter SQL still converts. Defaults to true."
                        },
                        "timestamp_domain": {
                            "type": "string",
                            "enum": ["aware", "naive"],
                            "description": "Declares whether this timestamp column stores an instant ('aware') or a bare wall clock ('naive'); overrides the warehouse catalog."
                        },
                        "hidden": {
                            "type": "boolean"
                        },
                        "round": {
                            "type": "number",
                            "minimum": 0
                        },
                        "format": {
                            "type": "string"
                        },
                        "separator": {
                            "$ref": "#/$defs/separator"
                        },
                        "time_intervals": {
                            "anyOf": [
                                {
                                    "type": "array",
                                    "items": {
                                        "anyOf": [
                                            {
                                                "type": "string",
                                                "enum": [
                                                    "RAW",
                                                    "DAY",
                                                    "WEEK",
                                                    "MONTH",
                                                    "QUARTER",
                                                    "YEAR",
                                                    "HOUR",
                                                    "MINUTE",
                                                    "SECOND",
                                                    "MILLISECOND",
                                                    "WEEK_NUM",
                                                    "MONTH_NUM",
                                                    "MONTH_NAME",
                                                    "DAY_OF_WEEK_NAME",
                                                    "QUARTER_NAME",
                                                    "DAY_OF_WEEK_INDEX",
                                                    "DAY_OF_MONTH_NUM",
                                                    "DAY_OF_YEAR_NUM",
                                                    "QUARTER_NUM",
                                                    "YEAR_NUM",
                                                    "HOUR_OF_DAY_NUM",
                                                    "MINUTE_OF_HOUR_NUM"
                                                ]
                                            },
                                            {
                                                "type": "string"
                                            }
                                        ]
                                    }
                                },
                                {
                                    "type": "string",
                                    "enum": ["default", "OFF"]
                                }
                            ]
                        },
                        "groups": {
                            "type": "array",
                            "description": "Groups are used to group dimensions and metrics in the sidebar. You can create nested groups up to 5 levels",
                            "items": {
                                "type": "string",
                                "minLength": 1
                            },
                            "maxItems": 5
                        },
                        "compact": {
                            "type": "string",
                            "enum": [
                                "auto",
                                "thousands",
                                "millions",
                                "billions",
                                "trillions",
                                "thousand",
                                "million",
                                "billion",
                                "trillion",
                                "K",
                                "M",
                                "B",
                                "T",
                                "kilobytes",
                                "megabytes",
                                "gigabytes",
                                "terabytes",
                                "petabytes",
                                "kilobyte",
                                "megabyte",
                                "gigabyte",
                                "terabyte",
                                "petabyte",
                                "KB",
                                "MB",
                                "GB",
                                "TB",
                                "PB",
                                "kibibytes",
                                "mebibytes",
                                "gibibytes",
                                "tebibytes",
                                "pebibytes",
                                "kibibyte",
                                "mebibyte",
                                "gibibyte",
                                "tebibyte",
                                "pebibyte",
                                "KiB",
                                "MiB",
                                "GiB",
                                "TiB",
                                "PiB"
                            ]
                        },
                        "urls": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "properties": {
                                    "url": {
                                        "type": "string",
                                        "description": "Liquidjs template for the URL. Available variables: ${value.raw}, ${value.formatted}, ${row.table_name.field_name.raw}, ${row.table_name.field_name.formatted}"
                                    },
                                    "label": {
                                        "type": "string"
                                    }
                                }
                            }
                        },
                        "image": {
                            "type": "object",
                            "description": "Displays the dimension value as an image",
                            "properties": {
                                "url": {
                                    "type": "string",
                                    "description": "Liquidjs template for the image URL. Available variables: ${value.raw}, ${value.formatted}, ${row.table_name.field_name.raw}, ${row.table_name.field_name.formatted}. Only fields selected in the query are available in row context."
                                }
                            },
                            "required": ["url"]
                        },
                        "tags": {
                            "oneOf": [
                                {
                                    "type": "string"
                                },
                                {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                }
                            ]
                        },
                        "required_attributes": {
                            "type": "object",
                            "properties": {},
                            "additionalProperties": {
                                "oneOf": [
                                    {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    },
                                    {
                                        "type": "string"
                                    }
                                ]
                            }
                        },
                        "any_attributes": {
                            "type": "object",
                            "properties": {},
                            "additionalProperties": {
                                "oneOf": [
                                    {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    },
                                    {
                                        "type": "string"
                                    }
                                ]
                            }
                        },
                        "spotlight": {
                            "type": "object",
                            "description": "Configure dimension visibility in the Metrics Explorer",
                            "properties": {
                                "filter_by": {
                                    "type": "boolean",
                                    "description": "Whether this dimension can be used for filtering in the Metrics Explorer. Defaults to true."
                                },
                                "segment_by": {
                                    "type": "boolean",
                                    "description": "Whether this dimension can be used for segmenting in the Metrics Explorer. Defaults to true."
                                }
                            }
                        },
                        "filter_autocomplete": {
                            "type": "object",
                            "description": "Configure static filter autocomplete suggestions and warehouse fetching for this dimension.",
                            "properties": {
                                "values": {
                                    "type": "array",
                                    "items": {
                                        "type": "object",
                                        "properties": {
                                            "value": {
                                                "type": "string"
                                            },
                                            "label": {
                                                "type": "string"
                                            }
                                        },
                                        "required": ["value"]
                                    }
                                },
                                "fetch_from_warehouse": {
                                    "type": "boolean",
                                    "description": "When false, filter autocomplete will not fetch values from the warehouse for this dimension. Defaults to true."
                                },
                                "label_dimension": {
                                    "type": "string",
                                    "description": "Name of another dimension in the same table whose value is shown as the display label for each warehouse-fetched value."
                                },
                                "options_from_dimension": {
                                    "type": "object",
                                    "description": "Fetch autocomplete values from a dimension in another model. Cascading filters are not applied.",
                                    "properties": {
                                        "model": {
                                            "type": "string"
                                        },
                                        "dimension": {
                                            "type": "string"
                                        },
                                        "label_dimension": {
                                            "type": "string"
                                        }
                                    },
                                    "required": ["model", "dimension"]
                                }
                            }
                        }
                    }
                },
                "additional_dimensions": {
                    "type": "object",
                    "patternProperties": {
                        "^[a-z0-9_]+$": {
                            "type": "object",
                            "properties": {
                                "type": {
                                    "type": "string",
                                    "enum": [
                                        "string",
                                        "number",
                                        "timestamp",
                                        "date",
                                        "boolean"
                                    ]
                                },
                                "label": {
                                    "type": "string",
                                    "minLength": 1
                                },
                                "description": {
                                    "type": "string",
                                    "minLength": 1
                                },
                                "ai_hint": {
                                    "$ref": "#/$defs/aiHint",
                                    "description": "Hints for AI-powered query generation"
                                },
                                "sql": {
                                    "type": "string",
                                    "minLength": 1
                                },
                                "time_intervals": {
                                    "anyOf": [
                                        {
                                            "type": "array",
                                            "items": {
                                                "anyOf": [
                                                    {
                                                        "type": "string",
                                                        "enum": [
                                                            "RAW",
                                                            "DAY",
                                                            "WEEK",
                                                            "MONTH",
                                                            "QUARTER",
                                                            "YEAR",
                                                            "HOUR",
                                                            "MINUTE",
                                                            "SECOND",
                                                            "MILLISECOND",
                                                            "WEEK_NUM",
                                                            "MONTH_NUM",
                                                            "MONTH_NAME",
                                                            "DAY_OF_WEEK_NAME",
                                                            "QUARTER_NAME",
                                                            "DAY_OF_WEEK_INDEX",
                                                            "DAY_OF_MONTH_NUM",
                                                            "DAY_OF_YEAR_NUM",
                                                            "QUARTER_NUM",
                                                            "YEAR_NUM",
                                                            "HOUR_OF_DAY_NUM",
                                                            "MINUTE_OF_HOUR_NUM"
                                                        ]
                                                    },
                                                    {
                                                        "type": "string"
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            "type": "string",
                                            "enum": ["default", "OFF"]
                                        }
                                    ]
                                },
                                "convert_timezone": {
                                    "type": "boolean",
                                    "description": "When false, this dimension is rendered in its raw warehouse value and is not converted to the project timezone for display. Filter SQL still converts. Defaults to true."
                                },
                                "timestamp_domain": {
                                    "type": "string",
                                    "enum": ["aware", "naive"],
                                    "description": "Declares whether this timestamp column stores an instant ('aware') or a bare wall clock ('naive'); overrides the warehouse catalog."
                                },
                                "hidden": {
                                    "type": "boolean"
                                },
                                "round": {
                                    "type": "number",
                                    "minimum": 0
                                },
                                "format": {
                                    "type": "string"
                                },
                                "separator": {
                                    "$ref": "#/$defs/separator"
                                },
                                "compact": {
                                    "type": "string",
                                    "enum": [
                                        "auto",
                                        "thousands",
                                        "millions",
                                        "billions",
                                        "trillions",
                                        "thousand",
                                        "million",
                                        "billion",
                                        "trillion",
                                        "K",
                                        "M",
                                        "B",
                                        "T",
                                        "kilobytes",
                                        "megabytes",
                                        "gigabytes",
                                        "terabytes",
                                        "petabytes",
                                        "kilobyte",
                                        "megabyte",
                                        "gigabyte",
                                        "terabyte",
                                        "petabyte",
                                        "KB",
                                        "MB",
                                        "GB",
                                        "TB",
                                        "PB",
                                        "kibibytes",
                                        "mebibytes",
                                        "gibibytes",
                                        "tebibytes",
                                        "pebibytes",
                                        "kibibyte",
                                        "mebibyte",
                                        "gibibyte",
                                        "tebibyte",
                                        "pebibyte",
                                        "KiB",
                                        "MiB",
                                        "GiB",
                                        "TiB",
                                        "PiB"
                                    ]
                                },
                                "group_label": {
                                    "type": "string",
                                    "deprecated": true,
                                    "description": "Deprecated: use groups instead"
                                },
                                "urls": {
                                    "type": "array",
                                    "items": {
                                        "type": "object",
                                        "properties": {
                                            "url": {
                                                "type": "string",
                                                "description": "Liquidjs template for the URL. Available variables: ${value.raw}, ${value.formatted}, ${row.table_name.field_name.raw}, ${row.table_name.field_name.formatted}"
                                            },
                                            "label": {
                                                "type": "string"
                                            }
                                        }
                                    }
                                },
                                "image": {
                                    "type": "object",
                                    "description": "Displays the dimension value as an image",
                                    "properties": {
                                        "url": {
                                            "type": "string",
                                            "description": "Liquidjs template for the image URL. Available variables: ${value.raw}, ${value.formatted}, ${row.table_name.field_name.raw}, ${row.table_name.field_name.formatted}. Only fields selected in the query are available in row context."
                                        }
                                    },
                                    "required": ["url"]
                                },
                                "tags": {
                                    "oneOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        }
                                    ]
                                },
                                "required_attributes": {
                                    "type": "object",
                                    "properties": {},
                                    "additionalProperties": {
                                        "oneOf": [
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "string"
                                            }
                                        ]
                                    }
                                },
                                "any_attributes": {
                                    "type": "object",
                                    "properties": {},
                                    "additionalProperties": {
                                        "oneOf": [
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "string"
                                            }
                                        ]
                                    }
                                },
                                "filter_autocomplete": {
                                    "type": "object",
                                    "description": "Configure static filter autocomplete suggestions and warehouse fetching for this dimension.",
                                    "properties": {
                                        "values": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "properties": {
                                                    "value": {
                                                        "type": "string"
                                                    },
                                                    "label": {
                                                        "type": "string"
                                                    }
                                                },
                                                "required": ["value"]
                                            }
                                        },
                                        "fetch_from_warehouse": {
                                            "type": "boolean",
                                            "description": "When false, filter autocomplete will not fetch values from the warehouse for this dimension. Defaults to true."
                                        },
                                        "label_dimension": {
                                            "type": "string",
                                            "description": "Name of another dimension in the same table whose value is shown as the display label for each warehouse-fetched value."
                                        },
                                        "options_from_dimension": {
                                            "type": "object",
                                            "description": "Fetch autocomplete values from a dimension in another model. Cascading filters are not applied.",
                                            "properties": {
                                                "model": {
                                                    "type": "string"
                                                },
                                                "dimension": {
                                                    "type": "string"
                                                },
                                                "label_dimension": {
                                                    "type": "string"
                                                }
                                            },
                                            "required": ["model", "dimension"]
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
